<script>
	import Box from '$lib/components/Box.svelte'
	import ShiftContent from '$lib/components/ShiftContent.svelte'
	import Table from '$lib/components/table/Table.svelte'
	import Td from '$lib/components/table/Td.svelte'
	import Th from '$lib/components/table/Th.svelte'
	import Tr from '$lib/components/table/Tr.svelte'
	import { STEP } from '$lib/consts'
	import { WOLTADVISOR, HEAT_PUMP } from '$lib/routes'
	import { Button } from '$lib/ui-woltair/components'

	let activeTab = 'tab1'
	export let tabs = [
		{
			id: 'tab1',
			label: 'Tab 1',
			content: '<p>Content for tab 1</p>'
		},
		{
			id: 'tab2',
			label: 'Tab 2',
			content: '<p>Content for tab 2</p>'
		},
		{
			id: 'tab3',
			label: 'Tab 3',
			content: '<p>Content for tab 3</p>'
		}
	]
	function handleTabClick(event) {
		activeTab = event.target.getAttribute('data-tab')
	}
</script>

<div class="items-bottom relative z-[2] flex w-full flex-nowrap justify-center px-4">
	{#each tabs as { id, label }}
		<button
			class="bold mx-2 block translate-y-[2px] border-neutral-200 bg-white p-2 px-4 {activeTab ===
			id
				? 'rounded-t-2xl border-l border-r border-t py-4'
				: 'mb-2 rounded-2xl border text-primary-500'}"
			data-tab={id}
			class:active={activeTab === id}
			on:click={handleTabClick}
		>
			{label}
		</button>
	{/each}
</div>
<Box cls="border relative z-[1]">
	<ShiftContent>
		<div class="tab-content overflow-x-auto">
			{#each tabs as { id, content }}
				{#if activeTab === id}
					<Table>
						<svelte:fragment slot="thead">
							<Tr>
								<Th />
								{#each content.woltAdvisorHvacFromQuery?.deviceTypes as data, _item}
									{#if _item < 3}
										<Th cls="pl-0 text-left min-w-[12em]">
											<div>{data.brandName}</div>
											<div class="text-sm font-normal">{data.withWater.name}</div>
										</Th>
									{/if}
								{/each}
							</Tr>
						</svelte:fragment>
						<svelte:fragment slot="tbody">
							<Tr>
								<Td border_r cls="pl-0">Úspora energie</Td>
								{#each content.woltAdvisorHvacFromQuery?.deviceTypes as data, _item}
									{#if _item < 3}
										<Td
											border_r={_item !== content.woltAdvisorHvacFromQuery?.deviceTypes.length - 1}
										>
											{Math.round(data.withWater.mwhSavings * 10) / 10} kWh
										</Td>
									{/if}
								{/each}
							</Tr>
							<Tr>
								<Td border_r cls="pl-0">
									Úspora CO
									<sub>2</sub>
								</Td>
								{#each content.woltAdvisorHvacFromQuery?.deviceTypes as data, _item}
									{#if _item < 3}
										<Td
											border_r={_item !== content.woltAdvisorHvacFromQuery?.deviceTypes.length - 1}
										>
											{Math.round(data.withWater.co2Savings * 10) / 10} tun
										</Td>
									{/if}
								{/each}
							</Tr>
							<Tr>
								<Td border_r cls="pl-0">Cena po dotaci</Td>
								{#each content.woltAdvisorHvacFromQuery?.deviceTypes as data, _item}
									{#if _item < 3}
										<Td
											cls="bold"
											border_r={_item !== content.woltAdvisorHvacFromQuery?.deviceTypes.length - 1}
										>
											{Math.round(
												data.withWater.purchasePrice -
													content.woltAdvisorHvacFromQuery.grantWithWater
											).toLocaleString('cs')} Kč
										</Td>
									{/if}
								{/each}
							</Tr>
							<Tr>
								<Td border_r cls="pl-0">Roční úspora</Td>
								{#each content.woltAdvisorHvacFromQuery?.deviceTypes as data, _item}
									{#if _item < 3}
										<Td
											cls="text-green-600 bold"
											border_r={_item !== content.woltAdvisorHvacFromQuery?.deviceTypes.length - 1}
										>
											{Math.round(data.withWater.annualMoneySavings).toLocaleString('cs')} Kč
										</Td>
									{/if}
								{/each}
							</Tr>
						</svelte:fragment>
					</Table>
				{/if}
			{/each}
		</div>
		<div class="center mb-6 mt-6">
			<Button tiny href="/{HEAT_PUMP}/{WOLTADVISOR}?{STEP}=start" cls="mt-4"
				>Chci kalkulaci na míru</Button
			>
		</div>
	</ShiftContent>
</Box>
